import React from 'react';

import PropTypes from 'prop-types';

import './DataLabelValue.css';

const DataLabelValueC = ({ dataLabelValue, ...props }) => {
  return (
    <div
      className="data-label-value"
      {...props}
      automationid={`SalesLead_Div_${props.automationidattr}DataLabelValue_0`}
    >
      {dataLabelValue}
    </div>
  );
};

DataLabelValueC.propTypes = {
  automationidattr: PropTypes.string,
  dataLabelValue: PropTypes.string,
};

const DataLabelValue = DataLabelValueC;

export default DataLabelValue;
